// extracted by mini-css-extract-plugin
export default {"warningPosition":"warningmessage_warningPosition__nEgRv"};